// context/AxiosContext.tsx
import { createContext, useContext, useMemo } from "react";
import axios, { AxiosInstance } from "axios";
import { useAxios } from "../hooks/useAxios";

const AxiosContext = createContext<AxiosInstance>(axios.create());

const AxiosProvider = ({ clientConfig, children }: { clientConfig: any; children: React.ReactNode }) => {
  const axiosInstance = useMemo(
    () =>
      axios.create({
        headers: {
          Accept: "application/json",
        },
      }),
    []
  );
  useAxios(clientConfig, axiosInstance);

  return (
    <AxiosContext.Provider value={axiosInstance}>
      {children}
    </AxiosContext.Provider>
  );
};

export const useAxiosClient = () => useContext(AxiosContext);

export { AxiosContext, AxiosProvider };